module.exports = __webpack_public_path__ + "img/zhicheng.prt.b54a622b.jpg";